/**
 * Set document.title to a project-aware string. Takes the current
 * project name + mode and produces titles like:
 *   - "Bliksys" (no project loaded)
 *   - "Acme Site — Bliksys" (content editor)
 *   - "Acme Site (schema) — Bliksys" (schema editor)
 *
 * Restores the original title on unmount so navigating back to the
 * landing page goes back to the plain "Bliksys".
 */

import { useEffect } from 'react';

import { decorateTitle } from '../environment.js';

export function useDocumentTitle(title: string | null): void {
  useEffect(() => {
    const previous = document.title;
    document.title = decorateTitle(title ?? 'Bliksys');
    return () => {
      document.title = previous;
    };
  }, [title]);
}
